@if (
  {
    brands: brandsListener?.data$ | async,
    mediaExpensesPercent: mediaExpensesPercentListener?.data$ | async
  };
  as STATE
) {
  <main class="subscriber-advertiser-details-page">
    <article class="subscriber-advertiser-details-page__header">
      <h1 class="subscriber-advertiser-details-page__title">
        {{ advertiser?.name }}
      </h1>
      <div>
        @if (STATE.brands; as brands) {
          @if (brands.length) {
            <mat-form-field>
              <mat-select
                placeholder="Sélectionner la marque"
                [(ngModel)]="globalBrand"
                (ngModelChange)="updateAllChartData()"
              >
                <mat-option value="">Toutes</mat-option>
                @for (brand of brands; track brand.id) {
                  <mat-option [value]="brand">{{ brand.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          } @else {
            <p>Aucune marque trouvé</p>
          }
        } @else {
          <loading-or-error
            spinnerSize="xl"
            loaderSize="xl"
            [error$]="brandsListener?.errorLoading$"
            (retry)="initBrandListener()"
          ></loading-or-error>
        }
      </div>
    </article>
    <article class="dashboard">
      <div>
        <div class="space-y-5">
          <ads-expenses-chart
            [advertiser]="advertiser"
            [globalBrand]="globalBrand"
          ></ads-expenses-chart>
          <ads-slots-chart
            [advertiser]="advertiser"
            [globalBrand]="globalBrand"
          ></ads-slots-chart>
          <!-- <section class="dashboard__card">
            <h2 class="dashboard__card__title">
              Dépenses publicitaires par média (FCFA)
            </h2>
            <div>
              <chart
                [listener]="adsExpensesListener"
                (retry)="initExpensesChart()"
              />

              <article class="dashboard__filters">
                <div>
                  <mat-form-field class="borderless">
                    <mat-select
                      placeholder="Sélectionner une marque"
                      [(ngModel)]="expensesBrandFilters[0]"
                      (ngModelChange)="initExpensesChart()"
                    >
                      @for (brand of STATE.brands; track brand.id) {
                        <mat-option [value]="brand">{{
                          brand.name
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field class="borderless">
                    <mat-select
                      placeholder="Sélectionner une marque"
                      [(ngModel)]="expensesBrandFilters[1]"
                      (ngModelChange)="initExpensesChart()"
                    >
                      @for (brand of STATE.brands; track brand.id) {
                        <mat-option [value]="brand">{{
                          brand.name
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </article>
            </div>
          </section> -->

          <!-- <section class="dashboard__card">
            <h2 class="dashboard__card__title">
              Tranches horaires les plus utilisées par les autres marque
              (Courbe)
            </h2>
            <div>
              <chart [listener]="adsSlotsListener" (retry)="initSlotsChart()" />
              <article class="dashboard__filters">
                <div>
                  <mat-form-field class="borderless">
                    <mat-select
                      placeholder="Sélectionner une marque"
                      [(ngModel)]="slotsBrandFilters[0]"
                      (ngModelChange)="initSlotsChart()"
                    >
                      @for (brand of STATE.brands; track brand.id) {
                        <mat-option [value]="brand">{{
                          brand.name
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field class="borderless">
                    <mat-select
                      placeholder="Sélectionner une marque"
                      [(ngModel)]="slotsBrandFilters[1]"
                      (ngModelChange)="initSlotsChart()"
                    >
                      @for (brand of STATE.brands; track brand.id) {
                        <mat-option [value]="brand">{{
                          brand.name
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </article>
            </div>
          </section> -->
        </div>

        <div class="space-y-5">
          <used-medias-chart
            [advertiser]="advertiser"
            [globalBrand]="globalBrand"
          ></used-medias-chart>

          <medias-expenses-chart
            [advertiser]="advertiser"
            [globalBrand]="globalBrand"
          ></medias-expenses-chart>
          <!-- <section class="dashboard__card">
            <h2 class="dashboard__card__title">Médias utilisés</h2>
            <article>
              <mat-radio-group class="circle-radio">
                <mat-radio-button
                  [value]=""
                  (change)="initUsedMediasChart()"
                  class="ads-creation-form__media-type__item"
                  >Toutes</mat-radio-button
                >
                @for (mediaType of mediaTypes | keyvalue; track mediaType) {
                  <mat-radio-button
                    (change)="initUsedMediasChart({ mediaType: $event.value })"
                    [value]="mediaType.key"
                    class="ads-creation-form__media-type__item"
                    >{{ mediaType.value }}</mat-radio-button
                  >
                }
              </mat-radio-group>
            </article>
            <div>
              <chart
                [listener]="usedMediasListener"
                (retry)="initUsedMediasChart()"
              />

              <article class="dashboard__filters">
                <div>
                  <mat-form-field class="borderless">
                    <mat-select
                      placeholder="Sélectionner une marque"
                      [(ngModel)]="mediasBrandFilters[0]"
                      (ngModelChange)="initUsedMediasChart()"
                    >
                      @for (brand of STATE.brands; track brand.id) {
                        <mat-option [value]="brand">{{
                          brand.name
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field class="borderless">
                    <mat-select
                      placeholder="Sélectionner une marque"
                      [(ngModel)]="mediasBrandFilters[1]"
                      (ngModelChange)="initUsedMediasChart()"
                    >
                      @for (brand of STATE.brands; track brand.id) {
                        <mat-option [value]="brand">{{
                          brand.name
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </article>
            </div>
          </section> -->

          <!-- <section class="dashboard__card">
            <h2 class="dashboard__card__title">
              Classement des médias où les marques investissent le plus
            </h2>

            <div>
              @if (STATE.mediaExpensesPercent?.length) {
                @for (
                  stat of STATE.mediaExpensesPercent;
                  track stat.mediaType
                ) {
                  <section class="dashboard__media-rating">
                    <p class="dashboard__media-rating__title">
                      {{ stat.mediaType | mediaType }}
                    </p>
                    <ngb-progressbar
                      class="mb-3"
                      [showValue]="true"
                      [value]="stat.totalAdvertisingExpense"
                    />
                  </section>
                } @empty {
                  <p>Aucune donnée</p>
                }
              } @else {
                <loading-or-error
                  [error$]="mediaExpensesPercentListener?.errorLoading$"
                  (retry)="initMediaExpensesPercentage(globalBrand?.id)"
                >
                </loading-or-error>
              }
            </div>
          </section> -->
        </div>
      </div>
    </article>
  </main>
}
